import localDB from "./localDB";

let GLOBAL = require('./globals');

const GalleyStoreData = {
    async list(page) {
        let response = await fetch(`${GLOBAL.BASE_URL}gallery-list?name=&page=${page}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}gallery-list`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}gallery/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
};

export default GalleyStoreData;


// WEBPACK FOOTER //
// ./src/data/GalleryStoreData.js